module.exports = __webpack_public_path__ + "img/edit_sign.91f190ad.svg";